import {makeAutoObservable} from "mobx";
import history from '../authentication/History';
import {toast} from 'react-toastify';
import environment from '../environments';
import {apiFetch, notifyError} from '../api';

const emptyClient = () => ({orderList: []});

class ClientStore
{

    clientList = [];
    client = emptyClient();
    /* ID of the record in client, so a different record never shows stale data */
    loadedId = null;

    start = 0;
    limit = 100;
    searchTerm = "";

    /* Endpoints */
    detailRoute = "/clients";
    dataEndpoint = environment.API_HOST + "/clients/list";
    searchEndpoint = environment.API_HOST + "/clients/search";

    /* Table configuration */
    sortBy = "customerid";
    sortOrder = "asc";
    tableColumns = [
        {name: "Kundennummer", field: "customerid", sortable: true},
        {name: "Firma", field: "company", sortable: true},
        {name: "Nachname", field: "lastname", sortable: true},
        {name: "Vorname", field: "firstname", sortable: true},
        {name: "Straße", field: "street", sortable: true},
        {name: "PLZ", field: "postalcode", sortable: true},
        {name: "Stadt", field: "city", sortable: true},
        {name: "Land", field: "country", sortable: true},
        {name: "Aufträge", field: "ordercount", sortable: true}
    ]

    constructor()
    {
        makeAutoObservable(this)
    }

    getClientList()
    {
        apiFetch(this.dataEndpoint + "?start=" + this.start + "&limit=" + this.limit + "&sortBy=" + this.sortBy + "&sortOrder=" + this.sortOrder)
            .then((json) =>
            {
                this.clientList = json.data
            })
            .catch((error) =>
            {
                notifyError(error);
                return error;
            })
    }

    searchClient()
    {
        /* Start again on the first page */
        this.start = 0;

        if (this.searchTerm && this.searchTerm.length > 0)
        {
            const term = this.searchTerm;
            apiFetch(this.searchEndpoint + "?term=" + encodeURIComponent(term))
                .then((json) =>
                {
                    if (term === this.searchTerm)
                    {
                        this.clientList = json.data
                    }
                })
                .catch((error) =>
                {
                    notifyError(error);
                })

        } else
        {
            this.getClientList();
        }
    }

    addClient()
    {
        apiFetch(environment.API_HOST + "/clients/new", {
            method: 'POST',
        })
            .then((json) =>
            {
                history.push('/clients/' + json.data.id)
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    getClient(id)
    {
        if (this.loadedId !== id)
        {
            this.client = emptyClient();
            this.loadedId = id;
        }

        apiFetch(environment.API_HOST + "/clients/" + id)
            .then((json) =>
            {
                /* Ignore responses for a record that is no longer open */
                if (id !== this.loadedId)
                {
                    return;
                }

                this.client = json.data[0]
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    saveClient(id)
    {
        var payload = {
            company: this.client.company,
            firstname: this.client.firstname,
            lastname: this.client.lastname,
            street: this.client.street,
            postalcode: this.client.postalcode,
            city: this.client.city,
            country: this.client.country,
            phone: this.client.phone,
            mobile: this.client.mobile,
            email: this.client.email,
        }

        payload = JSON.stringify(payload);

        apiFetch(environment.API_HOST + "/clients/" + id, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json"
            },
            body: payload
        })
            .then((json) =>
            {
                toast.success("Kunde erfolgreich gespeichert.");
                this.getClient(id);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    deleteClient(id)
    {
        apiFetch(environment.API_HOST + "/clients/" + id, {
            method: 'DELETE',
        })
            .then((json) =>
            {
                history.push('/clients')
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    sort(column)
    {
        /* Start again on the first page */
        this.start = 0;

        this.sortBy = column;

        if (this.sortOrder === 'asc')
        {
            this.sortOrder = 'desc';
        } else
        {
            this.sortOrder = 'asc';
        }

        this.getClientList();
    }

    nextPage()
    {
        this.start = this.start + this.limit
        this.getClientList();
    }

    previousPage()
    {
        if (this.start - this.limit >= 0)
        {
            this.start = this.start - this.limit
            this.getClientList();
        }
    }
}

const clientStore = new ClientStore();
export default clientStore;
